import { Transform } from "class-transformer"

import { CsvTransform } from "../helpers/csvTransform.helper"

/**
 * One CSV data row for payer mappings bulk upload.
 * Header names are mapped to these keys via PAYER_MAPPINGS_CONFIG.csvHeaderToKey before parsing.
 */
export class RawPayerMappingCsvRowDTO {
    @Transform(({ value }) => CsvTransform.trim(value))
    externalName: string

    @Transform(({ value }) => CsvTransform.trim(value))
    externalPayerId: string

    @Transform(({ value }) => CsvTransform.trim(value))
    payerId: string
}
